import { render, staticRenderFns } from "./dic_info_edit.vue?vue&type=template&id=c0d411b2&scoped=true"
import script from "./dic_info_edit.vue?vue&type=script&lang=js"
export * from "./dic_info_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d411b2",
  null
  
)

export default component.exports